import type { State, StateApi, StateFilters, States } from '../../models';

export const normalizeState = (state: StateApi): State => ({
  id: state.stateCode,
  label: state.stateDesc,
});

export const normalizeStates = (states: StateApi[]): States => {
  const list = states.map(normalizeState).sort((a, b) => a.label.localeCompare(b.label));

  return {
    list,
    map: list.reduce(
      (acc, state) => {
        acc[String(state.id)] = state;
        return acc;
      },
      {} as States['map'],
    ),
  };
};

export const filterStates = (states: States, filters: Partial<StateFilters> = {}): States => {
  let { list } = states;

  const searchQuery = filters.search?.stateDesc?.trim()?.toLowerCase();
  if (searchQuery) {
    list = list.filter((state) => {
      const name = state.label.toLowerCase();
      const code = String(state.id).toLowerCase();
      return name.includes(searchQuery) || code.includes(searchQuery);
    });
  }

  const stateCodeSearch = filters.search?.stateCode?.trim();
  if (stateCodeSearch) {
    const codes = stateCodeSearch.split(',').map((code) => code.trim().toLowerCase());
    list = list.filter((state) => codes.includes(String(state.id).toLowerCase()));
  }

  return {
    list,
    map: list.reduce(
      (acc, state) => {
        acc[String(state.id)] = state;
        return acc;
      },
      {} as States['map'],
    ),
  };
};
